// import './App.css';
import React, { useEffect } from 'react';
import { bindClientErrorReporter, reportClientException } from './utils/clientErrorLogger';
import { getAuthProps } from './utils/AuthenticationLibrary';
import LayoutNavigation from './navigation/LayoutNavigation';
import ComponentNavigation from '../src/navigation/ComponentNavigation';
import './css/style.scss';
import './css/responsive.scss';

class ErrorBoundary extends React.Component {
  componentDidCatch(error, errorInfo) {
    reportClientException(error, {
      source: 'react-error-boundary',
      project: 'sgtech-admin',
      componentStack: errorInfo?.componentStack || '',
      extra: {
        path: window.location.pathname,
        app: 'sgtech-admin',
      },
    });
  }

  render() {
    return this.props.children;
  }
}

function App() {
  const authDetails = getAuthProps();

  useEffect(() => {
    bindClientErrorReporter();
  }, []);

  if (window.location.pathname === "/") {
    window.location.href = "/Login";
  }
  else {
    if (window.location.pathname.toLocaleLowerCase() !== "/login" && window.location.pathname.toLocaleLowerCase() !== "/resetpassword" && window.location.pathname.toLocaleLowerCase() !== "/forgetpassword") {
      if (authDetails) {
        ComponentNavigation.forEach(element => {
          element.authDetails = authDetails;
        });
      }
      else {
        switch (window.location.pathname.toLocaleLowerCase()) {
          case "/resetpassword":
            window.location.href = "/ResetPassword";
            break;
          case "/forgetpassword":
            window.location.href = "/ForgetPassword";
            break;
          case "/login":
            window.location.href = "/Login";
            break;
          default:
            window.location.href = "/Login";

        }

      }
    }
  }

  return (
    <ErrorBoundary>
      <LayoutNavigation componentRoutes={ComponentNavigation} authDetails={authDetails} />
    </ErrorBoundary>
  );
}

export default App;
